// extracted by mini-css-extract-plugin
export default {"modal_mensage":"Dialog_modal_mensage__kPMUt","box_mensage":"Dialog_box_mensage__qKm-h","dialog":"Dialog_dialog__gWEr2","buttons":"Dialog_buttons__+e4uE"};